<template>
  <v-layout row>
    <v-flex
      xs12
      sm8
      offset-sm2
      lg4
      offset-lg4
    >
      <div class="title">
        <h3 class="headline mb-0">{{ $t('reset_password') }}</h3>
      </div>
      <v-card flat>
        <progress-bar :show="form.busy"></progress-bar>
        <form
          @submit.prevent="send"
          @keydown="form.onKeydown($event)"
        >
          <v-card-text>
            <!-- Email -->
            <email-input
              :form="form"
              :label="$t('email')"
              :v-errors="errors"
              :value.sync="form.email"
              name="email"
              v-validate="'required|email'"
            ></email-input>

            <submit-button
              block
              :form="form"
              dark
              :color="theme.btn_color_primary"
              :label="$t('send_password_reset_link')"
            ></submit-button>
          </v-card-text>
        </form>
      </v-card>
      <!-- <div class="login">
        <router-link :to="{ name: 'login' }">{{ $t('go_back') }}</router-link>
      </div> -->
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Form from 'vform'
import { isNavigationFailure } from 'vue-router/src/util/errors'

export default {
  name: 'email-view',
  layout: 'default',
  metaInfo () {
    return { title: this.$t('reset_password') }
  },
  data: () => ({
    form: new Form({
      email: '',
      loyalty_group_id: '',
      group_id: '',
      restaurant_id: '',
    })
  }),
  computed: {
    ...mapGetters('config', [
      'theme', 'loyaltyGroupId', 'gid', 'rid'
    ]),
  },
  methods: {
    async send () {
      if (await this.formHasErrors()) return

      const result = await axios.post('/api/user/by/email', {
        email: this.form.email,
        loyalty_group_id: this.loyaltyGroupId,
        group_id: this.gid,
        restaurant_id: this.rid,
      })

      if (result.data.social === 'facebook') {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Facebook Login',
          text: 'You registered with us via Facebook. Please login with Facebook.',
          modal: true
        })
        return
      } else if (result.data.social === 'google') {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Google+ Login',
          text: 'You registered with us via Google+. Please login with Google+.',
          modal: true
        })
        return
      }

      if (result.data) {
        this.form.loyalty_group_id = this.loyaltyGroupId;
        this.form.group_id = this.gid;
        this.form.restaurant_id = this.rid;
        const { data } = await this.form.post('/api/password/email')
      }

      this.$store.dispatch('responseMessage', {
        type: 'success',
        title: 'Reset Password',
        text: 'Our system will send instructions to reset your password if you have an existing account with us.',
        modal: true
      })

      this.$router.push({ name: 'welcome' }).catch(failure => {
        if (isNavigationFailure(failure)) {
          // show a small notification to the user
        }
      })
    }
  },
  created () {
    console.log('---email---')
    console.log(this.rid)
    console.log(this.gid);
    console.log('---email---')
  }
}
</script>

<style scoped>
.title {
  text-align: center;
  margin-top: 15px;
}
.login {
  text-align: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/password/email.vue